import script from "./NoInstanceHelper.vue?vue&type=script&setup=true&lang=js"
export * from "./NoInstanceHelper.vue?vue&type=script&setup=true&lang=js"

import "./NoInstanceHelper.vue?vue&type=style&index=0&id=36c77d30&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36c77d30"]])

export default __exports__